var Utils = require('@amzn/aws-workdocs-web-client-common').Utils;

(function(angular, _) {

'use strict';

angular.module('GorillaBoy.DocumentViewer')
.controller('DocumentTitleBarController', [
    '$rootScope',
    '$scope',
    '$timeout',
    '$uibModal',
    'AuthService',
    'authenticatedUser',
    'EndpointConfig',
    'TokenService',
    'BrowserService',
    'ContentTypeFormatter',
    'FavoritesService',
    'FeatureManagerService',
    '$routeParams',
    '$q',
    'Features',
    'RegionService',
    'CompanionService',
    'localStorageService',
    'MessageManager',
    'AppConstants',
    'CompanionClientService',
    'OrganizationService',
    '$location',
    '$translate',
    'SignalProvider',
    'ResourceService',
    DocumentTitleBarController]);

function DocumentTitleBarController($rootScope, $scope, $timeout, $uibModal, AuthService, authenticatedUser, EndpointConfig, TokenService, BrowserService, ContentTypeFormatter, FavoritesService, FeatureManagerService, $routeParams, $q, Features, RegionService,
    CompanionService, localStorageService, MessageManager, AppConstants, CompanionClientService, OrganizationService, $location, $translate, SignalProvider, ResourceService) {
    $scope.documentState.documentMenuOpen = false;
    $scope.documentState.documentMenuShowMore = false;
    $scope.documentState.versionDropdownOpen = false;

    var Favorites;
    var OSTypes = AppConstants.OSTypes;
    FeatureManagerService.getEnabledFeatureMap().then(function() {
        if (FeatureManagerService.isFeatureEnabled(Features.UI.FAVORITES)) {
            FavoritesService.getCachedUserFavorites().then(function(favs) {
                Favorites = favs;
            });
        } else {
            //Resolve with empty data.
            Favorites = {Documents : [], Folders : []};
        }
    });

    $scope.navigateToOnlineEditor = function() {
        $location.url('/document/' + $scope.metadata.Id + '?editOnline=true');
        return;
    };

    $scope.toggleDocumentSearch = function() {
        if (!$scope.documentState.documentViewerBridge) {
            return;
        }
        $scope.documentState.documentViewerBridge.toggleDocumentSearch();
        $scope.isSearchDisplayed = !$scope.isSearchDisplayed;
    };

    $scope.toggleVersionDropdown = function() {
        $scope.documentState.versionDropdownOpen = !$scope.documentState.versionDropdownOpen;
    };

    $scope.toggleDocMenu = function() {
        $scope.documentState.documentMenuOpen = !$scope.documentState.documentMenuOpen;
        if (!$scope.documentState.documentMenuOpen) {
            $scope.documentState.documentMenuShowMore = false;
        }
    };

    $scope.showMoreMenuItems = function() {
        $scope.documentState.documentMenuShowMore = true;
    };

    $scope.showMoreMenuItems = function() {
        $scope.documentState.documentMenuShowMore = true;
    };

    $scope.disableEnableDownloadClickHandler = function() {
        $scope.documentState.disallowDownload = !$scope.documentState.disallowDownload;
        $scope.togglePreventDownload();
        $scope.toggleDocMenu();
    };

    $scope.disableEnableFeedbackClickHandler = function() {
        $scope.documentFormData.disableFeedback = !$scope.documentFormData.disableFeedback;
        $scope.disableFeedbackChanged();
        $scope.toggleDocMenu();
    };

    $scope.isCurrentDocumentFavorite = function() {
        if (!$scope.metadata || !Favorites) {
            return false;
        }
        return Favorites.Documents.indexOf($scope.metadata.Id) !== -1;
    };

    $scope.toggleFavoriteCurrentDocument = function() {
        var docId;
        if (!$scope.metadata || !Favorites) {
            return;
        }
        docId = $scope.metadata.Id;
        var isFav = $scope.isCurrentDocumentFavorite();
        if (!isFav) {
            doLocalFav(true);
            FavoritesService.createFav(docId, AppConstants.FolderContentTypes.DOCUMENT)
            .then(null, restoreValue);
        } else {
            doLocalFav(false);
            FavoritesService.deleteFav(docId, AppConstants.FolderContentTypes.DOCUMENT)
            .then(null, restoreValue);
        }

        function restoreValue(response) {
            MessageManager.addErrorMessage($translate.instant('FAVORITES.SAVE_FAILURE'));
            //When the request is not successful remove the folderId from the list
            doLocalFav(isFav);
        }

        function doLocalFav(isFav) {
            if (isFav) {
                Favorites.Documents.push(docId);
            } else {
                Favorites.Documents = Favorites.Documents.filter(function(id) {
                    return id !== docId;
                });
            }
        }
    };

    /*
     * Below is for edit button and its tooltip on title bar
     */
    $scope.companionDownloadUrl = CompanionService.getCompanionDownloadUrl();

    $scope.showLockAndEditModal = function(useDrive) {
        // If the document is already locked by the current user, edit it directly.
        if ($scope.isDocumentCheckedOutByLoggedInUserCommon($scope.metadata)) {
            if (useDrive) {
                $scope.openWithDrive($scope.metadata);
            } else {
                $scope.openWithCompanion($scope.metadata);
            }
            return;
        }
        var LockAndEditModal = $uibModal.open({
            templateUrl: './shared/lock-and-edit-modal/lock-and-edit.html',
            controller: 'lockAndEditController',
            windowClass : 'dialog-box-2018 medium-style',
            resolve: {
                doc: $scope.metadata,
                lockFile: function() {
                    return $scope.checkoutHandler;
                },
                editWithCompanion: function() {
                    return useDrive ? $scope.openWithDrive : $scope.openWithCompanion;
                }
            }
        });

        $scope.$on("$destroy", function() {
            if (LockAndEditModal) {
                LockAndEditModal.close();
            }
        });
    };

    function showEditButton() {
        var isFileInEditableState = !$scope.isFileRecycled(),
            isDeviceSupported = !BrowserService.isMobileOrTablet(),
            isOSSupported = [OSTypes.WINDOWS, OSTypes.MAC].indexOf(BrowserService.getOS()) > -1,
            editEnabled = FeatureManagerService.isFeatureEnabled(Features.UI.FRICTIONLESS_EDIT);
        return isFileInEditableState && editEnabled && isOSSupported && isDeviceSupported;
    };

    function isDesktopAppEditEnabled() {
        return $rootScope.isFeatureEnabled($rootScope.Features.Desktop.DESKTOP_APP_EDIT);
    }
    
    function isAppEditShareLink() {
        // This is applicable to both Drive and Companion
        return $scope.hasShareLinkCurrentDocument() 
            && $rootScope.isFeatureEnabled($rootScope.Features.Desktop.DESKTOP_APP_NO_EDIT_SHARE_LINK);
    }

    $scope.showEditDriveButton = function() {
        return showEditButton() && isDesktopAppEditEnabled() && $rootScope.isFeatureEnabled($rootScope.Features.UI.COMPANION_TERMINATION_SWITCH);
    };
    $scope.showEditDriveButtonNew = function() {
        return showEditButton() && isDesktopAppEditEnabled() && !$rootScope.isFeatureEnabled($rootScope.Features.UI.COMPANION_TERMINATION_SWITCH);
    };

    $scope.showEditCompanionButton = function() {
        return showEditButton() && !isDesktopAppEditEnabled();
    };

    $scope.showEditCompanionRetiringButton = function() {
        return showEditButton() && isDesktopAppEditEnabled() && !$rootScope.isFeatureEnabled($rootScope.Features.UI.COMPANION_TERMINATION_SWITCH);
    };

    $scope.getEditDisabledReason = function(doc) {
        // Notice: For each of the reason in canEdit (except feature is disabled), this method must return a reason for it.
        // Thus, whether or not this method returns a string can be used to determine if file is editable.
        var msg,
            isOSSupported = [OSTypes.WINDOWS, OSTypes.MAC].indexOf(BrowserService.getOS()) > -1,
            MAC_COMPANION_MIN_VERSION = '1.0.81.0';

        if ($scope.isDocumentCheckedOutByAnApp(doc)) {
            return $translate.instant('FILE_ACTIONS.EDIT_DROPDOWN.LOCAL_EDIT_DISABLED_DUE_TO_LOCK');
        }

        // The order matters. Do checks for preventing companion from loading first.
        if(BrowserService.isMobileOrTablet()) {
            msg = $translate.instant('MESSAGES.FRICTIONLESS_EDIT.TOOLTIPS.DEVICE_NOT_SUPPORTED');
        } else if (!isOSSupported) {
            msg = $translate.instant('MESSAGES.FRICTIONLESS_EDIT.TOOLTIPS.OS_NOT_SUPPORTED');
        } else if($scope.isDocumentCheckedOutByOtherUser(doc)) {
            msg = $translate.instant('MESSAGES.FRICTIONLESS_EDIT.TOOLTIPS.NOT_EDITABLE_WHILE_LOCKED_BY_OTHERS');
        } else if (!$scope.showDownloadButton()) {
            msg = $translate.instant('MESSAGES.FRICTIONLESS_EDIT.TOOLTIPS.NOT_EDITABLE_WHILE_DOWNLOAD_DISABLED');
        } else if (!$scope.showUploadButton()) {
            msg = $translate.instant('MESSAGES.FRICTIONLESS_EDIT.TOOLTIPS.NOT_EDITABLE_WHILE_UPLOAD_DISABLED');
        } else if (!CompanionService.isCompanionConnectionPossible()) {
            // If companion connection is not possible (which means browser is not supported), enable user to click edit so that companionDownloadDialog can be shown
            // This condition check must happens before any other check that requires companion's state
            return msg;
        } else if (!$rootScope.companionDownloadButtonClicked && EndpointConfig.isPreviewSite() && BrowserService.getOS() === AppConstants.OSTypes.MAC &&
            (Utils.compareVersion(MAC_COMPANION_MIN_VERSION, CompanionClientService.getClient().getCompanionVersion()) > 0)) {
            msg = $translate.instant('MESSAGES.FRICTIONLESS_EDIT.TOOLTIPS.OLD_COMPANION', {companionDownloadUrl: $scope.companionDownloadUrl});
        } else if (isAppEditShareLink()) {
            // For Editing a share link document on WorkDocs Companion, it worked because the file get downloaded to a standalone non-syncable directory 
            // and it managed to upload to the cloud after user edit. However, since Companion downloaded the file to non-syncable directory, 
            // this raised security concern where the file does not get deleted if the link share is expired.  
            //
            // For Editing a share link document on Drive, this functionality is broken because all directories within Drive are frequently synced to the cloud and
            // there is no existing directories (e.g. My Documents/Share With Me) would be “fitted” to this concept of “Share Link”. 
            //
            // Native team is working on long term solution to support for “Share Link” document, but for now 
            // we will disable this feature for ShareLink as this caused data-loss for customers and security risk for Companion
            
            // If a share link document is also owned by this user or explicitly shared to this user (e.g. appear as in Group or User permission list)
            // it is a valid use case to edit the document.
            if (!$scope.hasExplicitEditPermissionForShareLinkDocument()) {
                msg = $translate.instant('MESSAGES.FRICTIONLESS_EDIT.TOOLTIPS.NOT_EDITABLE_WITH_SHARE_LINK');
            }
        }
        return msg;
    };

    $scope.getEditOnlineDisableMessage = function(metadata) {
                var disableMessage = '';

                if(ContentTypeFormatter.isPresentationFileFormat(metadata.VersionMetadata.ContentType) &&
                    metadata.VersionMetadata.Size > AppConstants.LIMITS.HUNDRED_MB_IN_BYTES) {

                    disableMessage = $translate.instant('ONLINEEDITING.ERRORS.PPT_FILE_SIZE_LIMIT_BREACHED');

                } else if(ContentTypeFormatter.isSpreadsheetFileFormat(metadata.VersionMetadata.ContentType) &&
                    metadata.VersionMetadata.Size > AppConstants.LIMITS.THIRTY_MB_IN_BYTES) {

                    disableMessage = $translate.instant('ONLINEEDITING.ERRORS.XLS_FILE_SIZE_LIMIT_BREACHED');

                } else if(ContentTypeFormatter.isWordFileFormat(metadata.VersionMetadata.ContentType) &&
                    metadata.VersionMetadata.Size > AppConstants.LIMITS.FIFTY_MB_IN_BYTES) {

                    disableMessage = $translate.instant('ONLINEEDITING.ERRORS.DOC_FILE_SIZE_LIMIT_BREACHED');

                } else if ($scope.isDocumentCheckedOut(metadata) && !$scope.isDocumentCheckedOutByHancom(metadata)) {
                    disableMessage = $translate.instant('Hancom.OPTION_DISABLED_DUE_TO_LOCK');
                } else if (!$scope.isOnlineEditableFileFormat()) {
                    disableMessage = $translate.instant('Hancom.OPTION_DISABLED_REASON');
                } else if(!$scope.showDownloadButton() || !$scope.checkUploadPermissionForEdit()) {
                    disableMessage = $translate.instant('ONLINEEDITING.ERRORS.CANNOT_EDIT_DOC_WITHOUT_DOWNLOAD_PERMISSION');
                }

                return disableMessage;
            };

    $scope.downloadClicked = function() {
        $rootScope.companionDownloadButtonClicked = true;
        $timeout(function() {
            $scope.toggleDocMenu();
        });
    };

    $scope.editButtonClicked = function(useDrive) {
        // Applicability check
        if (!useDrive && !CompanionService.isCompanionConnectionPossible()) {
            CompanionService.showCompanionNotSupportedModal();
            return;
        }
        
        if ($scope.getEditDisabledReason($scope.metadata)) {
            return;
        }
        
        $scope.showLockAndEditModal(useDrive);
    };

    $scope.openWithCompanion = function(doc) {
        CompanionService.openInFrictionlessEdit(doc,
            $scope.documentState.activeVersion.VersionId === doc.VersionMetadata.VersionId ? null : $scope.documentState.activeVersion.VersionId,
            $scope.passcode
        );
    };

    $scope.openWithDrive = function(doc) {
        CompanionService.openInDrive(doc);
    };

    $scope.isOwner = function() {
        return ResourceService.getOwnerId($scope.metadata) === $scope.userInfo.Id;
    };

    function isPurgeVersionsSupportedForFile(fileName) {
        var lowerCaseName = fileName.toLowerCase();
        return _.endsWith(lowerCaseName, '.pst') || _.endsWith(lowerCaseName, '.zip');
    }

    $scope.showPurgeVersionsOption = function() {
        return $scope.isFeatureEnabled(Features.DocumentViewer.PURGE_VERSIONS) &&
            $scope.isOwner() && isPurgeVersionsSupportedForFile($scope.metadata.VersionMetadata.Name) &&
            $scope.documentState.documentVersions.length >= 2 && //there exists at least 2 versions
            ($scope.documentState.documentVersions.length > AppConstants.PURGE_VERSIONS.VERSION_LIMIT ||
                $scope.documentState.totalVersionsSize > AppConstants.PURGE_VERSIONS.SIZE_LIMIT);
    };

    $scope.purgeVersionsClickHandler = function() {
        //Show the companion dialog if necessary before showing purge dialog box
        var modalHandle = $uibModal.open({
            templateUrl: './document-viewer/purge_versions_modal.html',
            controller: 'PurgeVersionsModalCtrl',
            size: 'md',
            windowClass: 'purge-versions-dialog',
            resolve: {
                'DocumentState' : function () {
                    return $scope.documentState;
                }
            }
        });
        $scope.$on("$destroy", function() {
            if (modalHandle) {
                modalHandle.close();
            }
        });
    };

    $scope.showLockOption = function() {
        var isLockOperationAllowed = !$scope.isFileRecycled();
        var isFileOwner = ResourceService.getOwnerId($scope.metadata) === $scope.userInfo.Id;  // userInfo is inherited from parent scope
        var showRequestCheckinOption = $scope.dropdownOptionAvailability.canRequestCheckin;
        return isLockOperationAllowed && (isFileOwner || !showRequestCheckinOption);
    };

    $scope.dropdownOptionAvailability = {};
    $scope.anyMenuOptionAvailable = function() {
        $scope.dropdownOptionAvailability = {
            showActivityFeed: !$scope.isMinimalUser && !$scope.isAnonymous,
            showDownloadButton: $scope.showDownloadButton(),
            showDownloadWithCommentsButton: ($scope.showDownloadWithCommentsButton() && $scope.isAnnotationReady()),
            canRequestCheckin: $scope.canRequestCheckin(),
            canDiscardCheckout: $scope.canDiscardCheckout(),
            showDiscardCheckout: $scope.canDiscardCheckout() && $scope.canCheckin(), // show button only if there is at least one draft version
            canUploadNewVersion: (!$scope.layout.isAnonymous && $scope.layout.showUploadPane && $scope.showDownloadButton() && (!$scope.isDocumentCheckedout() || $scope.isDocumentCheckedOutByLoggedInUser())),
            showDeleteButton: $scope.showDeleteButton(),
            canDisallowOtherDownload: !$scope.isFileRecycled() && $scope.hasSharePermission(),
            canDisableFeedback: ($scope.hasSharePermission() && $scope.showFeedbackSettings())
        };

        var thereIsOption = false;
        angular.forEach($scope.dropdownOptionAvailability, function(value, key) {
            if (value) {
                thereIsOption = true;
            }
        });

        return thereIsOption;
    };

    $scope.isActionMenuButtonVisible = function() {
        return $scope.anyMenuOptionAvailable();
    };

    $scope.isSettingsOptionVisible = function() {
        return !authenticatedUser.getUserInfo().MinimalUser;
    };

    $scope.isMoreOptionVisible = function() {
        return !authenticatedUser.getUserInfo().MinimalUser;
    };

    $scope.isFavoriteButtonVisible = function() {
        return !authenticatedUser.getUserInfo().MinimalUser;
    };

    $scope.atLeastOneAvailableOption = function() {

        // for minimal users edit is not allowed.
        if($scope.userInfo.MinimalUser){
            return false;
        }

        return $scope.showOpenWithOffice() || 
        showEditButton() || 
        $scope.showThinkFreeButton();
    };

    $scope.featureNotificationEditDescription = function() {
        return $translate.instant('FEATURE_NOTIFICATION.DRIVE.DESCRIPTION');
    };

    $scope.featureNotificationEditTitle = function() {
        return $translate.instant('FEATURE_NOTIFICATION.DRIVE.TITLE');
    };

    $scope.previouslyConnected = function() {
        if (CompanionClientService.getClient() && CompanionClientService.getClient().connectionChannel) {
            return CompanionClientService.getClient().connectionChannel.wasConnectedByQuickHandshake();
        } else {
            return false;
        }
    };
}

}(angular, _));
